var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4247_14256",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4247_14256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33325C7.44445 9.33325 6.97223 9.13881 6.58334 8.74992C6.19445 8.36103 6 7.88881 6 7.33325V3.33325C6 2.7777 6.19445 2.30547 6.58334 1.91659C6.97223 1.5277 7.44445 1.33325 8 1.33325C8.55556 1.33325 9.02778 1.5277 9.41667 1.91659C9.80556 2.30547 10 2.7777 10 3.33325V7.33325C10 7.88881 9.80556 8.36103 9.41667 8.74992C9.02778 9.13881 8.55556 9.33325 8 9.33325ZM8 13.9999C7.81111 13.9999 7.65289 13.9359 7.52534 13.8079C7.39734 13.6804 7.33334 13.5221 7.33334 13.3333V11.9499C6.3 11.8055 5.42223 11.3721 4.7 10.6499C3.97778 9.9277 3.53889 9.06103 3.38334 8.04992C3.35 7.86103 3.4 7.69436 3.53334 7.54992C3.66667 7.40547 3.84445 7.33325 4.06667 7.33325C4.22223 7.33325 4.36111 7.39147 4.48334 7.50792C4.60556 7.62481 4.68334 7.76659 4.71667 7.93325C4.86111 8.71103 5.23889 9.36103 5.85 9.88325C6.46111 10.4055 7.17778 10.6666 8 10.6666C8.82223 10.6666 9.53889 10.4055 10.15 9.88325C10.7611 9.36103 11.1389 8.71103 11.2833 7.93325C11.3167 7.76659 11.3973 7.62481 11.5253 7.50792C11.6529 7.39147 11.7944 7.33325 11.95 7.33325C12.1611 7.33325 12.3333 7.40547 12.4667 7.54992C12.6 7.69436 12.65 7.86103 12.6167 8.04992C12.4611 9.06103 12.0222 9.9277 11.3 10.6499C10.5778 11.3721 9.7 11.8055 8.66667 11.9499V13.3333C8.66667 13.5221 8.60289 13.6804 8.47534 13.8079C8.34734 13.9359 8.18889 13.9999 8 13.9999ZM8 7.99992C8.18889 7.99992 8.34734 7.93592 8.47534 7.80792C8.60289 7.68036 8.66667 7.52214 8.66667 7.33325V3.33325C8.66667 3.14436 8.60289 2.98592 8.47534 2.85792C8.34734 2.73036 8.18889 2.66659 8 2.66659C7.81111 2.66659 7.65289 2.73036 7.52534 2.85792C7.39734 2.98592 7.33334 3.14436 7.33334 3.33325V7.33325C7.33334 7.52214 7.39734 7.68036 7.52534 7.80792C7.65289 7.93592 7.81111 7.99992 8 7.99992Z",
    fill: "#212121"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.af9eaf2471075f3cab7932889e48e45e.svg";
export { ForwardRef as ReactComponent };